import pricingPlanBasic from '@assets/images/pricingPlanBasic.png';
import pricingPlanPremium from '@assets/images/pricingPlanPremium.png';
import pricingPlanPro from '@assets/images/pricingPlanPro.png';
import pricingPlanStandard from '@assets/images/pricingPlanStandard.png';
import { StaticImageData } from 'next/image';

const planDuration = ['monthly', 'yearly'] as const;
export type planDuration = typeof planDuration[number];

export type IPlanDetailSection = {
  section: string;
  description: string;
};

export interface IPlan {
  id: string;
  img: StaticImageData;
  title: string;
  subtitle: string;
  price: Record<planDuration, string>;
  unit: Record<planDuration, string>;
  unitDescription: string[];
  buttonText: string;
  detailSectionTitle?: string;
  detailSections: IPlanDetailSection[];
  isPopular: boolean;
}

export const Plans: IPlan[] = [
  {
    id: 'Basic pricing plan',
    img: pricingPlanBasic,
    title: 'Basic Starter',
    subtitle: 'Perfect for small teams to start rewarding and recognizing employees effortlessly.',
    price: {
      monthly: 'HK$0',
      yearly: 'HK$0',
    },
    unit: {
      monthly: 'per month',
      yearly: 'per year',
    },
    unitDescription: ['For 30 users or less'],
    buttonText: 'Start 30-days free trial!',
    detailSections: [
      {
        section: 'Motivate with points and badges',
        description: '',
      },
      {
        section: 'Share updates and news',
        description: '',
      },
      {
        section: 'Gather feedback with surveys',
        description: '',
      },
      {
        section: 'Connect members easily',
        description: '',
      },
    ],
    isPopular: false,
  },
  {
    id: 'Standard pricing plan',
    img: pricingPlanStandard,
    title: 'Standard',
    subtitle:
      'Ideal for growing companies that want to empower leaders and build a stronger community.',
    price: {
      monthly: 'HK$40',
      yearly: 'HK$384',
    },
    unit: {
      monthly: 'per month',
      yearly: 'per year',
    },
    unitDescription: ['For the first 30 users', '$20 for each additional user'],
    buttonText: 'Start 30-days free trial!',
    detailSectionTitle: 'Everything in Free plus',
    detailSections: [
      {
        section: 'Empower leaders with wallets',
        description: '',
      },
      {
        section: 'Facilitate networking opportunities',
        description: '',
      },
      {
        section: 'Access advanced backend management',
        description: '',
      },
      {
        section: 'Enjoy greater control and flexibility',
        description: '',
      },
    ],
    isPopular: true,
  },
  {
    id: 'Pro pricing plan',
    img: pricingPlanPro,
    title: 'Pro',
    subtitle:
      'Designed for larger organizations focused on structured training, workshops, and development.',
    price: {
      monthly: 'HK$49',
      yearly: 'HK$470',
    },
    unit: {
      monthly: 'per month',
      yearly: 'per year',
    },
    unitDescription: ['For the first 30 users', '$25 for each additional user'],
    buttonText: 'Coming soon!',
    detailSectionTitle: 'Everything in Standard plus',
    detailSections: [
      {
        section: 'Utilize comprehensive training',
        description: '',
      },
      {
        section: 'Onboard seamlessly with workshops',
        description: '',
      },
      {
        section: 'Organize engaging events',
        description: '',
      },
      {
        section: 'Track progress with robust analytics',
        description: '',
      },
    ],
    isPopular: false,
  },
  {
    id: 'Premium pricing plan',
    img: pricingPlanPremium,
    title: 'Premium',
    subtitle:
      'Best for data-driven enterprises looking to elevate engagement with advanced analytics.',
    price: {
      monthly: 'HK$59',
      yearly: 'HK$566',
    },
    unit: {
      monthly: 'per month',
      yearly: 'per year',
    },
    unitDescription: ['For the first 30 users', '$50 for each additional user'],
    buttonText: 'Coming soon!',
    detailSectionTitle: 'Everything in Pro plus',
    detailSections: [
      {
        section: 'Access via web and app',
        description: '',
      },
      {
        section: 'Integrate with existing systems',
        description: '',
      },
      {
        section: 'Champion ESG initiatives',
        description: '',
      },
      {
        section: 'Leverage in-depth data insights',
        description: '',
      },
    ],
    isPopular: false,
  },
];

export default Plans;
